import { useLang } from "../lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-gold/20 py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 grid place-items-center bg-gold text-ink font-display text-lg leading-none">A</span>
              <span className="font-display text-cream text-sm tracking-[0.25em]">AAYAT AI · CONCEPT STUDIO</span>
            </div>
            <p className="font-display italic text-gold text-lg tracking-[0.1em] mb-4">
              {t("footer.creed")}
            </p>
            <p className="text-cream/45 text-sm leading-relaxed max-w-md mb-8">
              {t("footer.desc")}
            </p>
            <a data-testid="footer-catalogue-btn" href="/AAYAT_Concept_Catalogue.pdf" download
              className="inline-flex items-center gap-3 border border-gold/60 text-gold text-[11px] tracking-[0.25em] uppercase px-6 py-3.5 hover:bg-gold hover:text-ink transition-[background-color,color] duration-300">
              {t("footer.catalogue")}
            </a>
          </div>
          <div className="text-cream/35 text-xs tracking-[0.2em] uppercase md:text-end space-y-2">
            <p>© {new Date().getFullYear()} {t("footer.rights")}</p>
            <p>{t("footer.credit")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
